module.exports = "<p>\r\n  print-pltshipment works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/print-pltshipment/print-pltshipment.component.html
// module id = ./src/app/print-pltshipment/print-pltshipment.component.html
// module chunks = main